import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import "swiper/css";
import { useDispatch, useSelector } from "react-redux";
import { postCart } from "../../../features/cart/cartSlice";
import { variant_type } from "../../../utils/common";

const Product_info = ({
  selectedVariant,
  setSelectedVariant,
  activeSize,
  activeTriple,
  activeMetal,
  setActiveTriple,
  setActiveSize,
  setActiveMetal,
  product,
  avg_rating,
}) => {
  const [activeColor, setActiveColor] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0); // default first card active
  const [activeIndex2, setActiveIndex2] = useState(0); // default first card active

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-cart?product_id=${product?.id}`);
  };

  const dispatch = useDispatch();

  const [quantity, setQuantity] = useState(1);

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const addToCart = async () => {
    try {
      const data = {
        product_id: product.id,
        variant_type_id: product.variant_type_id,

        // variant_id: selectedVariant?.id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        handleClick();
        if (res?.payload?.data?.success) {
        } else {
        }
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  // Auto select first available variant
  useEffect(() => {
    if (activeMetal?.Double_Variants?.length > 0) {
      setSelectedVariant(activeMetal?.Double_Variants?.[0]);
      setActiveSize(activeMetal?.Double_Variants?.[0]);
    }
  }, [activeMetal]);

  useEffect(() => {
    if (setActiveSize?.Triple_Variants?.length > 0) {
      setSelectedVariant(setActiveSize?.Triple_Variants?.[0]);
      setActiveTriple(setActiveSize?.Triple_Variants?.[0]);
    }
  }, [setActiveSize]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";
  return (
    <section className="Product_info">
      <div className="product_card">
        <div className="text_holder">
          <h4 className="">{product?.name}</h4>
          <div className="rating_holder">
            <p className="rating_text ">
              <Rating
                className="star_icons "
                initialRating={Number(avg_rating?.average_rating)}
                emptySymbol={<FontAwesomeIcon icon={farStar} color="#fff" />}
                fullSymbol={<FontAwesomeIcon icon={fasStar} color="#fff" />}
                fractions={2}
                readonly
              />
              {Number(avg_rating?.average_rating)} | {avg_rating?.total_counts}{" "}
              Reviews
            </p>
          </div>
          {selectedVariant && (
            <div className="price_holder">
              <h6 className="">
                <span className="discounted_price">
                  {symbol} {Number(selectedVariant.mrp * rate).toFixed(2)}
                </span>
                {symbol} {Number(selectedVariant.price * rate).toFixed(2)}
              </h6>
              <div className="save_div">
                <Green_btn
                  btnText={`Save: ${Math.round(
                    ((selectedVariant.mrp * rate -
                      selectedVariant.price * rate) /
                      (selectedVariant.mrp * rate)) *
                      100,
                  ) || 0}%`}
                />
              </div>

              <span className="mrp_holder">MRP (Inclusive of all taxes)</span>
            </div>
          )}
        </div>

        <div className="btn_holder ">
          <div className="add_cart_btn">
            {(product?.variant_type_id === 1
              ? selectedVariant?.general_stock
              : selectedVariant?.stock) <= 0 ? (
              <div
                className="stock_text_btn"
                product={product}
                // onClick={addToCart}
                quantity={quantity}
                setQuantity={setQuantity}
                selectedVariant={selectedVariant}
              >
                Out Of Stock
              </div>
            ) : (
              <Green_btn
                btnText="Add to Cart"
                product={product}
                onClick={addToCart}
                quantity={quantity}
                setQuantity={setQuantity}
                selectedVariant={selectedVariant}
              />
            )}
          </div>
          {/* {Number(selectedVariant?.general_stock) >= Number(quantity) ? (
          <Increment_decrement_btn_holder
            quantity={quantity}
            setQuantity={setQuantity}
          />
        ) : (
          <></>
        )} */}
        </div>
      </div>
    </section>
  );
};

export default Product_info;
